/**
 * @module core/aem
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { TEXT_CONSTANTS } from '@support/shared/constants/device.constants';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
// Environment settings
import { SETTINGS } from 'environments/settings';
import { CarousalImages } from '@support/api/common/product.interface';
import { CommonUtilService } from '@support/shared/services/common-util.service';

@Component({
  selector: 'tmo-product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrls: [
    '../../../../../style-sheets/components/page-titles.component.scss',
    '../../../../../style-sheets/components/input-radio.component.scss',
    '../../../../../style-sheets/components/gallery.component.scss',
  ],
})
export class ProductGalleryComponent implements OnInit, OnDestroy {
  /** Input variable to store Images array */
  public itemArray: Object[];

  /** Input variable to store Images array */
  @Input() public set carousalImages(images: CarousalImages[]) {
    if (this.objectService.get(images, 'length', 0)) {
      this.itemArray = images;
      this.startIndex = 0;
      this.endIndex = TEXT_CONSTANTS.CAROUSAL_SIZE;
      this.maxLength = this.itemArray.length;
      this.showImage(
        this.extTmoImagesUrl.concat(this.objectService.get(this.itemArray, '0.imagePath'))
      );
    }
  }

  /** Varibale to track which image is being displayed in main gallery */
  @Output() public activeImagePath: EventEmitter<string>;

  /** Varibale to track start index of array to display image */
  public startIndex: number;

  /** Varibale to track end index of array to display image */
  public endIndex: number;

  /** Varibale to track max images to display */
  public maxLength: number;
  /**
   * Holds the external domain URL to load images
   */
  public extTmoImagesUrl: string;

  /** Varibale to track max images to display */
  @Input() public carousalLength: number;
  /**
   * stores default image url
   */
  public imageUrl: string;

  /** Stores image name */
  public image: string;

  constructor(
    private objectService: ObjectService,
    private commonUtilService: CommonUtilService
  ) {
    this.activeImagePath = new EventEmitter<string>();
    this.startIndex = 0;
    this.endIndex = this.carousalLength;
    this.extTmoImagesUrl = SETTINGS.EXT_IMAGE_URL;
    this.image = TEXT_CONSTANTS.IMAGE;
  }

  /**
   * Method to move image by one item in right
   * @returns void
   */
  public moveRight(): void {
    this.startIndex++;
    this.endIndex++;
  }

  /**
   * Method to move image by one item in left
   * @returns void
   */
  public moveLeft(): void {
    this.startIndex--;
    this.endIndex--;
  }

  /**
   * Method to show image on click of its thumbnail
   * @param imagePath : Holds the path of image that needs to be shown
   * @returns void
   */
  public showImage(imagePath: string): void {
    this.activeImagePath.emit(imagePath);
  }

  /**
   * Component lifecycle hook to initialize the component
   * @returns void
   */
  public ngOnInit(): void {
    this.imageUrl = this.commonUtilService.getImageUrl('');
  }

  /**
   * Component lifecycle hook to destroy the component
   * @returns void
   */
  public ngOnDestroy(): void {}
}
